import {HookClass, Hook, BaseHook, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import {Observable, of} from 'rxjs';
import {parseDocument} from 'htmlparser2';
import * as domutils from 'domutils';
import {v4 as uuid} from 'uuid';

@HookClass('jsdom')
export class JSDomHook extends BaseHook {

    @Hook('421b6afa-d15a-4e92-b554-8aff9a913335')
    public parse(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        const $ = parseDocument(Buffer.from(inputArtifact.object.data, 'utf-8').toString());
        const resultArtifact = new NickProcessArtfact();
        resultArtifact.object =
            {
                data: $,
                __ignoreParser: {data: true}
            };
        return of(resultArtifact);
    }

    @Hook('1e6a5d0e-9f9f-43cd-988e-263d92471db3')
    public search(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        const resultArtifact = new NickProcessArtfact();
        resultArtifact.object = domutils.getElementsByTagName(((name: string) => ['h1', 'h2', 'p'].indexOf(name) >= 0), inputArtifact.object.data);
        resultArtifact.object.forEach((e: any) => {
            Object.defineProperty(e, 'innerText', {
                get() {
                    return domutils.textContent(e).trim();
                }
            });
        });
        resultArtifact.object = resultArtifact.object.map((e: any) => {
            return {innerText: domutils.textContent(e).trim()};
        });
        // resultArtifact.object = resultArtifact.object.splice(1, 5000);
        return of(resultArtifact);
    }

    @Hook('8b6482cd-2f4b-438c-8fbc-69f644442e3d')
    public lawParse(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        let testTitle = (el: any) => {
            if (!el.closest('h1'))
                return false;

            let str = el.innerText;
            if (!str || !str.length)
                return false;
            str = str.trim();
            return /^(TÍTULO )(I|V|X|L|C|D|M)+$/.test(str);
        };

        let isArt = (el: any) => {
            if (!el.closest('p'))
                return false;

            let str = el.innerText;
            if (!str || !str.length)
                return false;
            str = str.trim();

            return /^(Art. )([0-9])+/.test(str);
        };

        let isCharpter = (el: any) => {
            if (!el.closest('h2'))
                return false;

            let str = el.innerText;
            if (!str || !str.length)
                return false;
            str = str.trim();

            return /^(CAPÍTULO )(I|V|X|L|C|D|M|ÚNICO)+$/.test(str);
        };

        let isSection = (el: any) => {
            if (!el.closest('h3') && !el.closest('p'))
                return false;

            let str = el.innerText;
            if (!str || !str.length)
                return false;
            str = str.trim();

            return /^(Seção )(I|V|X|L|C|D|M)+$/.test(str);
        };

        let isInciso = (el: any) => {
            if (!el.closest('p'))
                return false;

            let str = el.innerText;
            if (!str || !str.length)
                return false;
            str = str.trim();

            return /^(I|V|X|L|C|D|M)+ (–|-|)/.test(str) || /^(I|V|X|L|C|D|M)+(–|-|)/.test(str);
        };

        let isParagraph = (el: any) => {
            if (!el.closest('p'))
                return false;

            let str = el.innerText;
            if (!str || !str.length)
                return false;
            str = str.trim();

            return /^(§)(\s|)([0-9])(º|o)/.test(str) || /^(Parágrafo único.)/.test(str);
        };

        let isAlinea = (el: any) => {
            if (!el.closest('p'))
                return false;

            let str = el.innerText;
            if (!str || !str.length)
                return false;
            str = str.trim();

            return /^([a-z])(\))/.test(str);
        };

        let isItem = (el: any) => {
            if (!el.closest('p'))
                return false;

            let str = el.innerText;
            if (!str || !str.length)
                return false;
            str = str.trim();

            return /^([0-9])(\.)/.test(str);
        };

        let isPreviewRedaction = (el: any) => {
            if (!el.closest('p'))
                return false;

            let str = el.innerText;

            if (!str || !str.length)
                return false;

            return str.startsWith('Redação Anterior');
        };

        let trim = (str: any) => {
            if (!str || !str.length)
                return null;

            return str.replace('\r\n', ' ').replace('  ', ' ').replace(' ', ' ').replace('', ' ').trim();
        };

        const syncId = inputArtifact.object.syncId;

        const resultArtifact = new NickProcessArtfact();
        resultArtifact.object = domutils.getElementsByTagName(((name: string) => ['h1', 'h2', 'h3', 'p'].indexOf(name) >= 0), inputArtifact.object.data);
        resultArtifact.object.forEach((e: any) => {
            Object.defineProperty(e, 'innerText', {
                get() {
                    return domutils.textContent(e).trim().replace('\r\n', ' ');
                }
            });

            e.closest = (el: any) => {
                let parent = e;
                do {
                    if (parent?.name == el) return parent;
                    parent = parent.parent;
                } while (parent != null);
                return null;
            };
        });

        const laws: any[] = [];

        /*
         * 0: titúlo
         * 1: capítulo
         * 2: section
         * 3: article
         * 4: isParagraph
         * 5: inciso
         * 6: alinea
         * 7: item
         */

        let currentTitleId: string;
        let currentChapterId: string;
        let currentSectionId: string;
        let currentArtId: string;
        let currentParagraphId: string;
        let currentIncisoId: string;
        let currentAlineaId: string;
        let currentItemId: string;

        let currentTitleName: any = null;
        let currentCharpterName: any = null;
        let currentSectionName: any = null;

        let nextLineIsOldRedaction: any = null;


        let index = 0;

        resultArtifact.object.filter((a: any) => {
            return a.innerText;
        })
            .forEach((el: any) => {
                const value = el.innerText ? el.innerText.trim() : null;

                if (!value || !value.length)
                    return;

                if (testTitle(el)) {
                    currentTitleId = null;
                    currentTitleName = null;

                    currentChapterId = null;
                    currentSectionId = null;
                    currentArtId = null;
                    currentParagraphId = null;
                    currentIncisoId = null;
                    currentAlineaId = null;

                    currentTitleId = uuid();
                    laws.push({
                        id: currentTitleId,
                        kind: 0,
                        text: `${el.innerText}`,
                        source: 0,
                        index,
                        syncId
                    });

                    index++;
                } else if (currentTitleId && !currentTitleName && el.closest('h1')) {
                    currentTitleName = el.innerText;
                    laws[laws.length - 1].text = `${laws[laws.length - 1].text} ${el.innerText}`;
                } else if (currentTitleId && currentTitleName) {


                    if (isCharpter(el)) {
                        // clear chapters
                        currentCharpterName = null;

                        nextLineIsOldRedaction = null;
                        currentSectionId = null;
                        currentArtId = null;
                        currentParagraphId = null;
                        currentIncisoId = null;
                        currentAlineaId = null;
                        currentItemId = null;

                        currentChapterId = uuid();

                        laws.push({
                            id: currentChapterId,
                            kind: 1,
                            text: trim(`${el.innerText}`),
                            parentId: currentTitleId,
                            source: 0,
                            index,
                            syncId
                        });
                        index++;
                    } else if (currentChapterId && !currentCharpterName && el.closest('h2')) {
                        laws[laws.length - 1].text = `${laws[laws.length - 1].text} ${el.innerText}`;
                    } else if (isSection(el)) {
                        // clear chapters
                        currentSectionName = null;

                        nextLineIsOldRedaction = null;
                        currentArtId = null;
                        currentParagraphId = null;
                        currentIncisoId = null;
                        currentAlineaId = null;
                        currentItemId = null;

                        currentSectionId = uuid();

                        laws.push({
                            id: currentSectionId,
                            kind: 2,
                            text: trim(`${el.innerText}`),
                            parentId: currentChapterId,
                            source: 0,
                            index,
                            syncId
                        });
                        index++;
                    } else if (currentSectionId && !currentSectionName && el.closest('h3')) {
                        currentSectionName = el.innerText;
                        laws[laws.length - 1].text = `${laws[laws.length - 1].text} ${el.innerText}`;
                    } else if (currentTitleId || currentChapterId || currentSectionId) {
                        if (isArt(el)) {
                            currentArtId = uuid();

                            currentParagraphId = null;
                            currentIncisoId = null;
                            currentAlineaId = null;
                            currentItemId = null;

                            laws.push({
                                id: currentArtId,
                                parentId: currentSectionId ? currentSectionId : (currentChapterId ? currentChapterId : currentTitleId),
                                kind: nextLineIsOldRedaction ? 3.1 : 3,
                                text: trim(`${el.innerText}`),
                                agregation: trim(nextLineIsOldRedaction),
                                source: 0,
                                index,
                                syncId
                            });

                            index++;
                            nextLineIsOldRedaction = null;
                        } else if (isPreviewRedaction(el)) {
                            nextLineIsOldRedaction = el.innerText;
                        } else if (isParagraph(el)) {
                            currentParagraphId = uuid();
                            currentIncisoId = null;
                            currentAlineaId = null;
                            currentItemId = null;

                            laws.push({
                                id: currentParagraphId,
                                parentId: currentArtId,
                                kind: nextLineIsOldRedaction ? 4.1 : 4,
                                text: trim(`${el.innerText}`),
                                agregation: trim(nextLineIsOldRedaction),
                                source: 0,
                                index,
                                syncId
                            });

                            index++;
                            nextLineIsOldRedaction = null;
                        } else if (isInciso(el)) {
                            currentIncisoId = uuid();
                            currentAlineaId = null;
                            currentItemId = null;

                            laws.push({
                                id: currentIncisoId,
                                parentId: currentParagraphId ? currentParagraphId : currentArtId,
                                kind: nextLineIsOldRedaction ? 5.1 : 5,
                                text: trim(`${el.innerText}`),
                                agregation: trim(nextLineIsOldRedaction),
                                source: 0,
                                index,
                                syncId
                            });

                            index++;
                            nextLineIsOldRedaction = null;
                        } else if (isAlinea(el)) {
                            currentAlineaId = uuid();
                            currentItemId = null;

                            laws.push({
                                id: currentAlineaId,
                                parentId: currentIncisoId,
                                kind: nextLineIsOldRedaction ? 6.1 : 6,
                                text: trim(`${el.innerText}`),
                                agregation: trim(nextLineIsOldRedaction),
                                source: 0,
                                index,
                                syncId
                            });

                            index++;
                            nextLineIsOldRedaction = null;
                        } else if (isItem(el)) {
                            currentItemId = uuid();

                            laws.push({
                                id: currentItemId,
                                parentId: currentAlineaId,
                                kind: nextLineIsOldRedaction ? 7.1 : 7,
                                text: trim(`${el.innerText}`),
                                agregation: trim(nextLineIsOldRedaction),
                                source: 0,
                                index,
                                syncId
                            });

                            index++;
                            nextLineIsOldRedaction = null;
                        }
                    }
                }
            });

        // melhorar: contribuinte deverá manter pelo | redação anterior ficou errada

        resultArtifact.object = laws;
        return of(resultArtifact);
    }

    @Hook('c071d89f-15ea-4347-bc41-1bd7b932d4b4')
    public decreeParse(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        let isDecreeNumber = (el: any) => {
            let str = el.innerText;
            if (!str || !str.length)
                return false;
            str = str.trim();
            return /^(([0-9]|\.|[0-9])+), de ([0-9]+(\.[0-9]+)+)$/.test(str.split('      ')[0]);
        };

        let trim = (str: any) => {
            if (!str || !str.length)
                return null;

            return str.replace('\r\n', ' ').replace('  ', ' ').replace(' ', ' ').replace('', ' ').trim();
        };

        const syncId = inputArtifact.object.syncId;

        const resultArtifact = new NickProcessArtfact();
        resultArtifact.object = domutils.getElementsByTagName(((name: string) => ['td'].indexOf(name) >= 0), inputArtifact.object.data);
        resultArtifact.object.forEach((e: any) => {
            Object.defineProperty(e, 'innerText', {
                get() {
                    return domutils.textContent(e).trim().replace('\r\n', ' ');
                }
            });

            e.closest = (el: any) => {
                let parent = e;
                do {
                    if (parent?.name == el) return parent;
                    parent = parent.parent;
                } while (parent != null);
                return null;
            };
        });

        const laws: any[] = [];

        /*
         * 0: titúlo
         * 1: capítulo
         * 2: section
         * 3: article
         * 4: isParagraph
         * 5: inciso
         * 6: alinea
         * 7: item
         */

        let currentNumber: any = null;
        let currentLink: any = null;


        let index = 0;

        resultArtifact.object.filter((a: any) => {
            return a.innerText;
        })
            .forEach((el: any) => {
                const value = el.innerText ? el.innerText.trim() : null;

                if (!value || !value.length)
                    return;

                if (!currentNumber && isDecreeNumber(el)) {
                    currentNumber = el.innerText;
                } else if (currentNumber) {
                    laws.push({
                        agregation: trim(currentNumber),
                        text: trim(el.innerText),
                        index,
                        source: 1,
                        syncId
                    });

                    index++;
                    currentNumber = null;
                }
            });

        resultArtifact.object = laws;
        return of(resultArtifact);
    }

    @Hook('a127c02d-00c4-43d3-8c30-eb88a71bc9a1')
    public ordinanceYearParse(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        let isYearNumber = (el: any) => {
            let str = el.innerText;
            if (!str || !str.length)
                return false;
            str = str.trim();
            return /^([0-9][0-9][0-9][0-9])$/.test(str);
        };

        const resultArtifact = new NickProcessArtfact();
        resultArtifact.object = domutils.getElementsByTagName(((name: string) => ['td'].indexOf(name) >= 0), inputArtifact.object.data);
        resultArtifact.object.forEach((e: any) => {
            Object.defineProperty(e, 'innerText', {
                get() {
                    return domutils.textContent(e).trim().replace('\r\n', ' ');
                }
            });

            e.closest = (el: any) => {
                let parent = e;
                do {
                    if (parent?.name == el) return parent;
                    parent = parent.parent;
                } while (parent != null);
                return null;
            };
        });

        const laws: any[] = [];

        /*
         * 0: titúlo
         * 1: capítulo
         * 2: section
         * 3: article
         * 4: isParagraph
         * 5: inciso
         * 6: alinea
         * 7: item
         */

        let currentNumber: any = null;
        let currentLink: any = null;

        resultArtifact.object.filter((a: any) => {
            return a.innerText;
        })
            .forEach((el: any) => {
                const value = el.innerText ? el.innerText.trim() : null;

                if (!value || !value.length)
                    return;

                if (isYearNumber(el)) {
                    currentNumber = el.innerText;
                    currentLink = el.children[0].attributes[0].value;

                    if (currentLink.endsWith('.htm'))
                        laws.push({
                            link: currentLink,
                            year: el.innerText
                        });
                }
            });

        resultArtifact.object = laws;
        return of(resultArtifact);
    }

    @Hook('67db3073-6065-48c1-9f45-c4a12cec7eb8')
    public ordinanceParse(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        let isOrdinanceNumber = (el: any) => {
            let str = el.innerText;
            if (!str || !str.length)
                return false;
            str = str.trim();
            return /^[a-zA-Z]+ n/.test(str.split('      ')[0]);
        };

        let isDecreeNumber = (el: any) => {
            let str = el.innerText;
            if (!str || !str.length)
                return false;
            str = str.trim();
            return /^(([0-9]|\.|[0-9])+), de ([0-9]+(\.[0-9]+)+)$/.test(str.split('      ')[0]);
        };

        let isDecreeNumberNoDots = (el: any) => {
            let str = el.innerText;
            if (!str || !str.length)
                return false;
            str = str.trim();
            return /^(([0-9]|\.|[0-9])+)|(([0-9])+), de ([0-9]+(\.[0-9]+)+)$/.test(str.split('      ')[0]);
        };


        let trim = (str: any) => {
            if (!str || !str.length)
                return null;

            return str.replace('\r\n', ' ').replace('  ', ' ').replace(' ', ' ').replace('', ' ').trim();
        };

        const resultArtifact = new NickProcessArtfact();
        resultArtifact.object = domutils.getElementsByTagName(((name: string) => ['td'].indexOf(name) >= 0), inputArtifact.object.data);
        resultArtifact.object.forEach((e: any) => {
            Object.defineProperty(e, 'innerText', {
                get() {
                    return domutils.textContent(e).trim().replace('\r\n', ' ');
                }
            });

            e.closest = (el: any) => {
                let parent = e;
                do {
                    if (parent?.name == el) return parent;
                    parent = parent.parent;
                } while (parent != null);
                return null;
            };
        });

        const syncId = inputArtifact.object.syncId;

        const laws: any[] = [];

        /*
         * 0: titúlo
         * 1: capítulo
         * 2: section
         * 3: article
         * 4: isParagraph
         * 5: inciso
         * 6: alinea
         * 7: item
         */

        let currentNumber: any = null;
        let currentLink: any = null;


        let index = parseInt(inputArtifact.object.index + '0000');

        resultArtifact.object.filter((a: any) => {
            return a.innerText;
        })
            .forEach((el: any) => {
                const value = el.innerText ? el.innerText.trim() : null;

                if (!value || !value.length)
                    return;

                if (!currentNumber && (isOrdinanceNumber(el) || isDecreeNumber(el) || isDecreeNumberNoDots(el))) {
                    currentNumber = el.innerText;
                } else if (currentNumber) {
                    laws.push({
                        agregation: trim(currentNumber),
                        text: trim(el.innerText),
                        index,
                        source: 2,
                        syncId
                    });

                    index++;
                    currentNumber = null;
                }
            });

        resultArtifact.object = laws;
        return of(resultArtifact);
    }
}
